import React, { useState } from 'react';
import { Tag, Text, TipShareBreakdown } from 'components';
import { Size } from 'design/types';
import { DEFAULT_POOL_NAME, ICalculatorRule, IFormCalculatorRule } from 'types';
import { displayContributorType, toTitleCase } from 'utils';
import { ItemContainer, StyledIconButton } from '../../../styles';
import { Column, DivWithGap, StyledButtonText, StyledRow } from '../../shared/styles';

interface ITipShareItemProps {
  tipShare: IFormCalculatorRule | ICalculatorRule;
  disabled?: boolean;
  alwaysVisible?: boolean;
  onEdit?(): void;
  onDelete?(): void;
}

export const TipShareItem: React.FC<ITipShareItemProps> = ({ tipShare, disabled, alwaysVisible, onEdit, onDelete }) => {
  const [rulesVisible, setRulesVisible] = useState(alwaysVisible || false);
  return (
    <ItemContainer data-cy="tip-share-item">
      <StyledRow>
        <Column>
          <Column gap={1}>
            {tipShare && !tipShare.default && <Text size="xxsmall">{displayContributorType(tipShare)}</Text>}
            <DivWithGap>
              <Text size="small" fontWeight="semibold" capitalize allowWordWrap>
                {tipShare?.default ? `${DEFAULT_POOL_NAME} Rules` : toTitleCase(tipShare?.contributor?.name)}
              </Text>
              {tipShare?.isVirtual && !tipShare.default && <Tag label="Virtual" size={Size.SMALL} />}
            </DivWithGap>
          </Column>

          {!alwaysVisible && <StyledButtonText label={rulesVisible ? 'Hide Rules' : 'View Rules'} onClick={() => setRulesVisible(!rulesVisible)} />}
        </Column>

        {!disabled && (
          <div>
            <StyledIconButton label="Edit" appearance="white" size="small" icon="Edit" data-cy="edit-button" onClick={onEdit} disabled={disabled} />
            <StyledIconButton label="Remove" onClick={onDelete} appearance="white" size="small" icon="Close" data-cy="remove-button" disabled={disabled} />
          </div>
        )}
      </StyledRow>

      {rulesVisible && <TipShareBreakdown tipShare={tipShare} />}
    </ItemContainer>
  );
};
